module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_auto-9a023ca18e0142c929dc3285d7c7ffc3.jpg";